module.exports = __webpack_public_path__ + "static/logo-b153e1dcb2753565d59cf05b3451bed0.jpg";